import { useState } from 'react';

import { type ResolvableModalFC } from '@/components/modals/modalsManager';
import { Input } from '@/components/ui';
import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/dialog';

/** Resolves to the trimmed secret the sender issued, or null when the user cancels. */
export const WebhookSenderSecretModal: ResolvableModalFC<
  { endpointName: string },
  string | null
> = ({ open, onOpenChange, resolve, endpointName }) => {
  const [secret, setSecret] = useState('');
  const trimmedSecret = secret.trim();

  const close = (result: string | null) => {
    resolve(result);
    onOpenChange(false);
  };

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(next) => {
        if (!next) resolve(null);
        onOpenChange(next);
      }}
    >
      <Dialog.Content className="max-w-md">
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (trimmedSecret) close(trimmedSecret);
          }}
        >
          <Dialog.Header>
            <Dialog.Title>Use {endpointName}&apos;s own secret</Dialog.Title>
            <Dialog.Description>
              Some services, such as Stripe, issue their own signing secret.
              Paste it here to replace this endpoint&apos;s current secret.
            </Dialog.Description>
          </Dialog.Header>
          <Input
            type="password"
            aria-label="Sender's secret"
            placeholder="e.g. whsec_…"
            autoFocus
            autoComplete="off"
            maxLength={1024}
            value={secret}
            onChange={(event) => setSecret(event.target.value)}
            className="my-3"
          />
          <Dialog.Footer>
            <Button type="button" variant="ghost" onClick={() => close(null)}>
              Cancel
            </Button>
            <Button type="submit" disabled={!trimmedSecret}>
              Save
            </Button>
          </Dialog.Footer>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};
